export default __webpack_public_path__ + "static/47-f2736fdec863300d325d1027ad32c859.png";